module.exports = __webpack_public_path__ + "img/fz-1.2ed9bbe4.png";